import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {store} from "global/store";
import {Provider} from "react-redux";
import {ThemeProvider} from "./context";
import {UIErrorBoundary} from "components";
import {ErrorBoundary} from "react-error-boundary";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ErrorBoundary
    fallback={<UIErrorBoundary />}
    children={
      <Provider
        store={store}
        children={
          <ThemeProvider>
            <App />
          </ThemeProvider>
        }
      />
    }
  />
);
